const TableHeader = ({ children, className, ...rest }) => {
  return (
    <div className={`tableHeader ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default TableHeader;
